function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Company_svg__20_a"
}, React.createElement("stop", {
  stopColor: "#60ADF7",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#3386EE",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
  fill: "url(#Company_svg__20_a)"
}), React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M28 20h-2a2 2 0 00-2 2v10h-3a1 1 0 00-1 1v3h-7a1 1 0 01-1-1V23.562a2 2 0 011.515-1.94L18 20.5V16a2 2 0 012-2h6a2 2 0 012 2v4zm-7.5 8a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm4 0a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm-10 16a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm0-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z",
  fillRule: "nonzero",
  opacity: 0.499
}), React.createElement("path", {
  d: "M27 22h10a1 1 0 011 1v6a1 1 0 01-1 1H27a1 1 0 01-1-1v-6a1 1 0 011-1zm0 10h10a1 1 0 011 1v2a1 1 0 01-1 1H27a1 1 0 01-1-1v-2a1 1 0 011-1zm1.5-8a.5.5 0 000 1h7a.5.5 0 100-1h-7zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 7a.5.5 0 100 1h6a.5.5 0 100-1h-6z"
})));

var SvgCompany = function SvgCompany(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    width: 50,
    height: 50
  }, props), _ref, _ref2);
};

export default SvgCompany;